import React, { useState, useEffect } from 'react';
import { Box, Typography, Grid, Chip, Skeleton } from '@mui/material';
import { withTranslation, Trans } from 'react-i18next';
import { CheckOutlined } from '@mui/icons-material';
import api from '../services/api';

const ProfilingSectors = ({ handleChange, handleStatus, q }) => {
  const [selected, setSelected] = useState([]);
  const [sectors, setSectors] = useState(null);
  const [loading, setLoading] = useState(false);
  const loadingElements = 16

  useEffect(() => {
    loadSectors();
  }, []);

  const loadSectors = () => {
    setLoading(true)
    api.get('v2/mz/wa/sectors', { cache: false })
      .then(response => {
        const sectors = response.data;
        setSectors(sectors);
        setLoading(false)
      })
      .catch(error => {
        console.log(error);
        setLoading(false)
      });
  };

  const handleChipClick = value => {
    let updatedSelected = [...selected];
    if (!updatedSelected.includes(value)) {
      updatedSelected.push(value);
    } else {
      updatedSelected = updatedSelected.filter(v => v !== value);
    }
    setSelected(updatedSelected);
    handleChange(q, updatedSelected);
    handleStatus(q, updatedSelected.length > 0);
  };

  return (
    <Box sx={{ py: 2 }}>
      <Typography gutterBottom variant='body2'><Trans components={{ b: <b></b> }}>q_4</Trans></Typography>
      <Grid container spacing={1}>
        {
          loading ?
            Array.from({ length: loadingElements }, (_, i) =>
              <Grid item xs={6} sm={4} md={4} lg={3} key={'empty_' + i}>
                <Skeleton sx={{ height: 32, transform: 'none', m: 1 }} />
              </Grid>
            )
            :
            sectors && !loading ? sectors.map((item) => {
              const checked = selected.includes(item.v);
              return (
                <Grid item xs={6} sm={4} md={4} lg={3} key={item.l}>
                  <Chip
                    sx={{ m: 1, minWidth: "100%" }}
                    size='medium'
                    variant={checked ? 'plain' : 'filled'}
                    color={checked ? 'primary' : 'default'}
                    label={item.l}
                    icon={checked ? <CheckOutlined /> : ''}
                    onClick={() => {
                      handleChipClick(item.v);
                    }}
                  />
                </Grid>
              );
            }) : <Box sx={{ p: 2 }}>Data not found</Box>}
      </Grid>
    </Box>
  );
};

export default withTranslation()(ProfilingSectors);
